import type { ITheme } from '../contexts/ThemeContext';

export const navBarPaddingTop = { xs: 24, lg: 24 }
export const homePaddingY = { xs: 12, lg: 12 }
export const homePaddingX = { xs: 28, lg: 0 }

// Helper to get alternating section background
export const getSectionStyle = (theme: ITheme, index: number): React.CSSProperties => {
    const isEven = index % 2 === 0;
    return {
        background: isEven ? theme.gradients.sectionA : theme.gradients.sectionB,
    };
};

// Helper to get pill style based on category/kind
export const getPillStyle = (theme: ITheme, kind: string): React.CSSProperties => {
    const kindLower = kind.toLowerCase();
    
    // Map service lines to colors
    if (kindLower.includes('waste') || kindLower.includes('recycle')) {
        return {
            backgroundColor: `${theme.colors.primary}15`,
            borderColor: theme.colors.primary,
            color: theme.colors.primary,
        };
    }
    if (kindLower.includes('compliance') || kindLower.includes('register')) {
        return {
            backgroundColor: `${theme.colors.secondary}15`,
            borderColor: theme.colors.secondary,
            color: theme.colors.secondary,
        };
    }
    if (kindLower.includes('energy') || kindLower.includes('waste-to-energy')) {
        return {
            backgroundColor: `${theme.colors.feature}15`,
            borderColor: theme.colors.feature,
            color: theme.colors.feature,
        };
    }
    if (kindLower.includes('training') || kindLower.includes('capacity')) {
        return {
            backgroundColor: `${theme.colors.accent}15`,
            borderColor: theme.colors.accent,
            color: theme.colors.accent,
        };
    }
    if (kindLower.includes('assessment') || kindLower.includes('environmental')) {
        return {
            backgroundColor: `${theme.colors.highlight}15`,
            borderColor: theme.colors.highlight,
            color: theme.colors.highlight,
        };
    }
    
    // Default
    return {
        backgroundColor: `${theme.colors.primary}15`,
        borderColor: theme.colors.primary,
        color: theme.colors.primary,
    };
};

// Helper to get card style with variant
export const getCardStyle = (theme: ITheme, variant: 'default' | 'primary' | 'secondary' = 'default'): React.CSSProperties => {
    const baseStyle: React.CSSProperties = {
        backgroundColor: theme.colors.surface,
        border: `1px solid ${theme.colors.border}`,
        borderTop: `3px solid ${variant === 'primary' ? theme.colors.primary : variant === 'secondary' ? theme.colors.secondary : theme.colors.border}`,
        borderRadius: theme.borderRadius.r1,
        boxShadow: theme.shadow.cardShadow,
    };
    
    return baseStyle;
};

// Helper to get icon background style
export const getIconBackgroundStyle = (theme: ITheme, color: 'primary' | 'secondary' | 'accent' | 'highlight' | 'feature' = 'primary'): React.CSSProperties => {
    const colorMap = {
        primary: theme.colors.primary,
        secondary: theme.colors.secondary,
        accent: theme.colors.accent,
        highlight: theme.colors.highlight,
        feature: theme.colors.feature,
    };
    
    return {
        backgroundColor: `${colorMap[color]}15`,
        color: colorMap[color],
        borderRadius: '50%',
        padding: '8px',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
    };
};
